(function (root) {
  'use strict';
  const KEY = 'yizcho.purchase.route.v1';
  const TTL = 30 * 60 * 1000;
  const PRODUCT = '/products/pawcho-odd-eyed-tuxedo-cat-art-doll';
  const PRODUCT_ID = '9876829569272';
  const ENTRY_KEYS = new Set(['all_products', 'stock_house', 'other_home', 'other_internal', 'external_product', 'direct_product', 'unknown']);
  const PAGE_KEYS = new Set(['black_cat', 'all_products', 'island_home', 'milk']);
  const EVIDENCE_KEYS = new Set(['observed_click', 'same_site_referrer', 'marked_same_site_link', 'quick_add', 'direct_or_unknown', 'retained_variant_view']);

  function page(path) {
    if (path === PRODUCT) return 'milk';
    if (path === '/products/magical-black-cat-halloween-ooak') return 'black_cat';
    if (path === '/collections/all-products' || path === '/collections/all') return 'all_products';
    if (path === '/' || path === '') return 'island_home';
    return '';
  }

  function privacyState(w) {
    try {
      const privacy = w.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
      const result = privacy.analyticsProcessingAllowed();
      return typeof result === 'boolean' ? result : null;
    } catch (_) { return null; }
  }

  function createRecorder(options) {
    let state = null;
    const now = options.now || Date.now;
    const permitted = () => { try { return options.allowed() === true; } catch (_) { return false; } };
    const clear = () => {
      state = null;
      try { options.storage?.removeItem(KEY); } catch (_) {}
    };
    const save = () => {
      if (!state || !permitted()) return;
      state.updated = now();
      try { options.storage?.setItem(KEY, JSON.stringify(state)); } catch (_) {}
    };
    function load() {
      if (!permitted()) { clear(); return null; }
      if (!state) {
        try {
          const candidate = JSON.parse(options.storage?.getItem(KEY) || 'null');
          if (candidate?.v === 1 && /^[a-f0-9-]{36}$/.test(candidate.id)
            && Number.isFinite(candidate.updated) && now() >= candidate.updated && now() - candidate.updated < TTL
            && Array.isArray(candidate.path) && candidate.path.length <= 12 && candidate.path.every(p => PAGE_KEYS.has(p))
            && (!candidate.first || ENTRY_KEYS.has(candidate.first)) && (!candidate.last || ENTRY_KEYS.has(candidate.last))
            && (!candidate.evidence || EVIDENCE_KEYS.has(candidate.evidence))) state = candidate;
        } catch (_) {}
      }
      if (state && (now() - state.updated >= TTL || now() < state.updated)) clear();
      if (!state) {
        let id;
        try { id = options.makeId(); } catch (_) { return null; }
        if (!/^[a-f0-9-]{36}$/.test(id || '')) return null;
        state = { v: 1, id, updated: now(), first: '', last: '', evidence: '', path: [], pending: null };
      }
      return state;
    }
    function append(p) {
      if (PAGE_KEYS.has(p) && state.path.at(-1) !== p) state.path = [...state.path, p].slice(-12);
    }
    function entry(source, evidence) {
      state.first ||= source;
      state.last = source;
      state.evidence = evidence;
    }
    function visit(context) {
      if (!load()) return null;
      if (context.external && !context.resume) { clear(); if (!load()) return null; }
      append(page(context.path));
      if (page(context.path) === 'milk') {
        const pending = state.pending;
        if (pending && ENTRY_KEYS.has(pending.source) && PAGE_KEYS.has(pending.from)
          && Number.isFinite(pending.at) && now() >= pending.at && now() - pending.at < 15000
          && (context.resume || (context.internal && page(context.referrerPath) === pending.from))) {
          entry(pending.source, 'observed_click');
        } else if (context.internal && page(context.referrerPath) === 'all_products') {
          entry('all_products', 'same_site_referrer');
        } else if (context.internal && page(context.referrerPath) === 'island_home' && context.marker === 'stock_house') {
          entry('stock_house', 'marked_same_site_link');
        } else if ((context.resume || (context.internal && page(context.referrerPath) === 'milk')) && state.last) {
          state.evidence = 'retained_variant_view';
        } else {
          entry(context.external ? 'external_product' : context.internal
            ? (page(context.referrerPath) === 'island_home' ? 'other_home' : 'other_internal')
            : 'direct_product', 'direct_or_unknown');
        }
        state.pending = null;
      }
      save();
      return snapshot();
    }
    function link(source, from) {
      if (!ENTRY_KEYS.has(source) || !PAGE_KEYS.has(from) || !load()) return null;
      state.pending = { source, from, at: now() };
      save();
      return snapshot();
    }
    function snapshot() { return state ? JSON.parse(JSON.stringify(state)) : null; }
    function properties(contextPage, commit) {
      if (!load()) return {};
      const original = snapshot();
      if (contextPage === 'all_products') { entry('all_products', 'quick_add'); append('all_products'); }
      if (!state.last) entry('unknown', 'direct_or_unknown');
      const capture = snapshot();
      if (commit) save();
      else state = original;
      return {
        _yz_route_v: '1',
        _yz_journey_id: capture.id,
        _yz_entry_first: capture.first,
        _yz_entry_last: capture.last,
        _yz_entry_evidence: capture.evidence,
        _yz_page_path: capture.path.join('>')
      };
    }
    function touch(context) {
      if (!load()) return null;
      append(page(context.path));
      save();
      return snapshot();
    }
    return { visit, link, properties, clear, snapshot, touch };
  }

  function install(w) {
    const d = w.document;
    if (d.documentElement.dataset.yizchoPurchaseRoute === '1') return;
    d.documentElement.dataset.yizchoPurchaseRoute = '1';
    const routeRoot = d.currentScript?.dataset.root || '/';
    const localizedRoot = routeRoot.endsWith('/') ? routeRoot : routeRoot + '/';
    function pathOf(url) {
      let p = url.pathname.replace(/\/$/, '') || '/';
      if (localizedRoot !== '/' && p.startsWith(localizedRoot)) p = '/' + p.slice(localizedRoot.length);
      if (localizedRoot !== '/' && p === localizedRoot.slice(0, -1)) p = '/';
      return p;
    }
    function context() {
      const here = new URL(w.location.href);
      let referrer = null;
      try { if (d.referrer) referrer = new URL(d.referrer); } catch (_) {}
      return { path: pathOf(here), marker: here.searchParams.get('yz_entry') || '',
        internal: !!referrer && referrer.origin === here.origin,
        external: !!referrer && referrer.origin !== here.origin,
        referrerPath: referrer && referrer.origin === here.origin ? pathOf(referrer) : '' };
    }
    function allowed() {
      return privacyState(w) === true;
    }
    let storage;
    try { storage = w.sessionStorage; } catch (_) {}
    const recorder = createRecorder({ allowed, storage, makeId: () => w.crypto.randomUUID() });
    w.YizchoPurchaseRoute = { touch: () => allowed() ? recorder.touch(context()) : null,
      snapshot: () => allowed() ? recorder.snapshot() : null };
    let initialized = false;
    let queued = false;
    let lastClarityTag = '';
    const ownedLinks = new WeakSet();
    const mark = () => {
      const s = recorder.snapshot();
      if (!allowed() || !s || typeof w.clarity !== 'function') return;
      const tag = s.id + ':' + s.last;
      if (lastClarityTag === tag) return;
      try {
        w.clarity('set', 'yizcho_purchase_journey', s.id);
        if (s.last) w.clarity('set', 'yizcho_milk_entry', s.last);
        lastClarityTag = tag;
      } catch (_) {}
    };
    function sourceFor(anchor) {
      const current = page(context().path);
      if (current === 'all_products') return 'all_products';
      if (current === 'island_home' && anchor.closest('#yizcho-stock-room')
        && (anchor.matches('.ysr-buy') || anchor.matches('.ysr-cat'))) return 'stock_house';
      return current === 'island_home' ? 'other_home' : 'other_internal';
    }
    function milkLink(anchor) {
      try { const u = new URL(anchor.href, w.location.href); return u.origin === w.location.origin && pathOf(u) === PRODUCT; }
      catch (_) { return false; }
    }
    function decorateLinks() {
      for (const anchor of d.querySelectorAll('a[href*="/products/pawcho-odd-eyed-tuxedo-cat-art-doll"]')) {
        if (!milkLink(anchor)) continue;
        const u = new URL(anchor.href, w.location.href);
        if (!allowed()) {
          if (ownedLinks.has(anchor)) { u.searchParams.delete('yz_entry'); anchor.href = u.href; ownedLinks.delete(anchor); }
          continue;
        }
        const source = sourceFor(anchor);
        if (source === 'all_products' || source === 'stock_house') {
          if (u.searchParams.get('yz_entry') !== source) { u.searchParams.set('yz_entry', source); anchor.href = u.href; }
          ownedLinks.add(anchor);
        }
      }
    }
    function isMilkForm(form) {
      if (!form?.matches?.('form')) return false;
      const component = form.closest('product-form-component');
      if (component) return component.dataset.productId === PRODUCT_ID;
      return form.querySelector('input[name="product-id"]')?.value === PRODUCT_ID;
    }
    function writeForm(form, data, commit) {
      if (!isMilkForm(form)) return;
      const props = allowed() ? recorder.properties(page(context().path), !!commit) : {};
      if (data) for (const key of ['_yz_route_v', '_yz_journey_id', '_yz_entry_first', '_yz_entry_last', '_yz_entry_evidence', '_yz_page_path']) data.delete('properties[' + key + ']');
      for (const input of form.querySelectorAll('input[data-yz-route-field]')) input.remove();
      for (const [key, value] of Object.entries(props)) {
        const input = d.createElement('input');
        input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.value = value;
        input.dataset.yzRouteField = '1'; form.append(input);
        if (data) data.set(input.name, value);
      }
      mark();
    }
    function sync() {
      const permission = privacyState(w);
      d.documentElement.dataset.yizchoPurchaseRouteStatus = permission === null ? 'awaiting_privacy_api'
        : permission ? 'active' : 'awaiting_analytics_permission';
      if (permission !== true) {
        if (permission === false) recorder.clear();
        initialized = false; lastClarityTag = '';
      }
      else if (!initialized) { recorder.visit(context()); initialized = true; }
      decorateLinks();
      for (const form of d.querySelectorAll('product-form-component form, form[action*="/cart/add"]')) writeForm(form);
      mark();
    }
    function schedule() {
      if (queued) return;
      queued = true;
      w.queueMicrotask(() => { queued = false; try { sync(); } catch (_) {} });
    }
    d.addEventListener('click', event => {
      try {
        if (!allowed()) return;
        const anchor = event.target.closest?.('a[href]');
        if (anchor && milkLink(anchor)) {
          recorder.link(sourceFor(anchor), page(context().path));
          mark();
        }
        const form = event.target.closest?.('form');
        if (form) writeForm(form);
      } catch (_) {}
    }, true);
    d.addEventListener('submit', event => { try { writeForm(event.target, null, true); } catch (_) {} }, true);
    d.addEventListener('formdata', event => { try { writeForm(event.target, event.formData, true); } catch (_) {} }, true);
    d.addEventListener('visitorConsentCollected', schedule);
    d.addEventListener('shopify:section:load', schedule);
    w.addEventListener('pageshow', event => {
      if (event.persisted && allowed()) { recorder.visit({ ...context(), resume: true }); initialized = true; }
      schedule();
    });
    new w.MutationObserver(records => {
      if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 &&
        (n.matches?.('form, product-form-component, a[href]') || n.querySelector?.('form, product-form-component, a[href]'))))) schedule();
    }).observe(d.documentElement, { childList: true, subtree: true });
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', schedule, { once: true });
    else schedule();
    try {
      if (!w.Shopify?.customerPrivacy && typeof w.Shopify?.loadFeatures === 'function') {
        w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => schedule());
      }
    } catch (_) {}
    for (const delay of [500, 2000, 5000]) w.setTimeout(schedule, delay);
  }

  if (typeof module === 'object' && module.exports) module.exports = { createRecorder, page, KEY, TTL, install };
  else if (root?.document) { try { install(root); } catch (_) {} }
})(typeof window === 'undefined' ? null : window);
